import { render, staticRenderFns } from "./waybillAdd.vue?vue&type=template&id=3adb5330&scoped=true"
import script from "./waybillAdd.vue?vue&type=script&lang=js"
export * from "./waybillAdd.vue?vue&type=script&lang=js"
import style0 from "./waybillAdd.vue?vue&type=style&index=0&id=3adb5330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb5330",
  null
  
)

export default component.exports